const unavailable = "—";

function formatStatus(value) {
  const text = String(value || "").trim();
  if (!text) return "Unknown";
  return text
    .toLowerCase()
    .replace(/[_-]+/g, " ")
    .replace(/\b\w/g, (character) => character.toUpperCase());
}

function statusTone(value) {
  const normalized = String(value || "").toUpperCase();
  if (normalized === "ACTIVE" || normalized === "RUNNING") return "online";
  if (
    normalized === "DISABLED" ||
    normalized === "STOPPED" ||
    normalized === "INACTIVE" ||
    normalized === "ERROR"
  ) {
    return "offline";
  }
  return "connecting";
}

function timeframesOf(strategy) {
  return Array.isArray(strategy.required_timeframes)
    ? strategy.required_timeframes.filter(
        (timeframe) => typeof timeframe === "string" && timeframe.trim()
      )
    : [];
}

export function buildStrategyCards(strategies) {
  return strategies.map((strategy, index) => {
    const id = String(strategy.strategy_id || "");
    const timeframes = timeframesOf(strategy);

    return {
      key: id || `strategy-${index}`,
      name: String(strategy.strategy_name || "") || id || "Unnamed strategy",
      eyebrow: timeframes.length
        ? `${timeframes.join(" · ")} timeframes`
        : "Timeframes unavailable",
      status: formatStatus(strategy.status),
      tone: statusTone(strategy.status),
      stats: [
        { label: "Strategy ID", value: id || unavailable },
        {
          label: "Required timeframes",
          value: timeframes.length ? timeframes.join(", ") : unavailable,
        },
        // GoldBot does not publish per-strategy risk or results in the runtime
        // snapshot, so these stay empty rather than showing invented numbers.
        { label: "Risk / trade", value: unavailable },
        { label: "Total trades", value: unavailable },
        { label: "Win rate", value: unavailable },
        { label: "Total result", value: unavailable },
      ],
    };
  });
}

export function getStrategiesState({ data, error, isLoading }) {
  if (isLoading && !data) {
    return { eyebrow: "Loading strategies", message: "Loading strategies..." };
  }
  if (error) {
    return { eyebrow: "API unavailable", message: "Strategies unavailable" };
  }
  if (!data || !Array.isArray(data.strategies) || data.strategies.length === 0) {
    return {
      eyebrow: "No strategies",
      message: "No strategies are registered",
    };
  }
  if (data.stale) {
    return { eyebrow: "Stale snapshot", message: null };
  }
  return {
    eyebrow: `${data.active_count ?? 0} active of ${data.strategies.length}`,
    message: null,
  };
}
